import { createContext, type ReactNode, useContext, useState } from 'react';

interface SidebarContextType {
	expanded: Record<string, boolean>;
	toggleExpand: (key: string) => void;
	setExpanded: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export function ProviderSideBar({ children }: { children: ReactNode }) {
	const [expanded, setExpanded] = useState<Record<string, boolean>>({});

	const toggleExpand = (key: string) => {
		setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
	};

	return (
		<SidebarContext.Provider value={{ expanded, toggleExpand, setExpanded }}>
			{children}
		</SidebarContext.Provider>
	);
}

export function useSidebarContext() {
	const context = useContext(SidebarContext);
	if (!context) {
		throw new Error('useSidebarContext must be used within a ProviderSideBar');
	}
	return context;
}
